import { NoteTargetName, NoteTargetType } from '@converge/graphql';

import { ConvergeNotes } from '../../../notes';
import { FormContainerWithHeader } from '../../../../presentation';
import { useUnderwritingSubmissionStateContext } from '../../underwriting.submission.context';

interface IProps {
  isReadonly: boolean;
}

export const UnderwritingOverviewUnderwritingCommentsFormSection = ({
  isReadonly,
}: IProps) => {
  const {
    submission: { uuid },
  } = useUnderwritingSubmissionStateContext();

  return (
    <FormContainerWithHeader title="Underwriting Notes">
      <ConvergeNotes
        title="Underwriting notes"
        targetName={NoteTargetName.Submission}
        targetType={NoteTargetType.Node}
        label={['underwriting_notes', 'renewal_notes']}
        targetUuid={uuid}
        hideHeader
        containerWidth={12}
        testId="underwriting-comments"
        callHandleUpdateRenewalType={() => {}}
      />
    </FormContainerWithHeader>
  );
};
